import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';

import { Drawer, Empty } from 'antd';
import { db } from 'firebase/firebase';
import { collection, orderBy,query, where } from 'firebase/firestore';
import moment from 'moment';

import BoxContainer from 'components/BoxContainer';
import Title from 'components/BoxContainer/components/Title';
import ExecutionItem from 'components/ExecutionItem';
import FilterContainer from 'components/FilterContainer';
import InfiniteScroll from 'components/InfiniteScroll';

import { PATHS } from 'packages/dashboard/constants';
import {
  getFullUrl,
  sortByField,
  useFirestoreQuery,
  useFirestoreRealtimeBatched,
} from 'packages/utils';
import { getActiveAndNextExecutions } from 'packages/utils/functions/executions';

import IntlMessages from 'util/IntlMessages';

const SchedulesActive = () => {
  const { userId } = useParams();
  const history = useHistory();
  const { url } = useRouteMatch();

  const currentPageFromState = history.location.state?.currentPage || 1;

  const orgId = useSelector(state => state.organizations.organization.id);

  const { data: userData, loading: userLoading } = useFirestoreQuery(
    query(collection(db, 'organizations', orgId, 'users'), where('id', '==', userId)),
    [orgId, userId],
  );
  const user = userData?.[0];
  const userDivisions = user?.divisions;

  // Build query per divisions
  const divisionsPerUser = useMemo(() => {
    if (!userDivisions) return [];
    return Object.keys(userDivisions);
  }, [userDivisions]);
  const queryByDivId = divisionsPerUser.map(divId =>
    query(
      collection(db, 'organizations', orgId, 'divisions', divId, 'executions'),
      where('usersWithAccess', 'array-contains', user?.id),
      where('endAt', '>', moment().subtract(1, 'day').toDate()),
      orderBy('endAt', 'desc'),
    ),
  );

  const { data, loading, gotNewData, next } = useFirestoreRealtimeBatched(queryByDivId, [
    divisionsPerUser,
  ]);

  const { activeExecutions } = getActiveAndNextExecutions(data);

  const executionsActiveSorted = sortByField(activeExecutions, 'createdAt');

  const mainLoading = loading || userLoading;
  return (
    <Drawer open={!!userId} onClose={() => history.goBack()} closable={false} footer={null}>
      <BoxContainer>
        <BoxContainer content fixed>
          <FilterContainer
            goBack={() =>
              history.push({
                pathname: getFullUrl(PATHS.ACTIVE_USER_DASHBOARD, url),
                state: {
                  currentPage: currentPageFromState,
                },
              })
            }
            title={
              <Title.Header
                value={<IntlMessages id="activeUserDashboard.schedule.inprogress.column" />}
              />
            }
          />
        </BoxContainer>
        <BoxContainer content loading={mainLoading}>
          {executionsActiveSorted?.length > 0 ? (
            executionsActiveSorted.map(execution => (
              <ExecutionItem key={execution.id} execution={execution} />
            ))
          ) : (
            <Empty description={<IntlMessages id="execution.empty.state" />} />
          )}
          <InfiniteScroll condition={!mainLoading && gotNewData} callback={next} />
        </BoxContainer>
      </BoxContainer>
    </Drawer>
  );
};

export default SchedulesActive;
